import styled from 'styled-components';

import {
  fieldVariables,
  inputContainerBaseStyles,
  inputElStyles,
  inputLabelBaseStyles,
} from '@xemplo/input-utils';
import { BodySmallSemiBold, BodyXSmallSemiBold } from '@xemplo/style-constants';

export const Wrapper = styled.div`
  ${fieldVariables};
  max-width: var(--input-width);
  width: 100%;
`;

export const TextAreaContainer = styled.div`
  ${inputContainerBaseStyles};
  align-items: flex-start;
  height: auto;
  min-height: var(--input-height);
  width: fit-content;
  min-width: 100%;
  position: relative;

  > svg {
    margin-top: 12px;
    color: var(--input-trailing-icon-color);
    position: relative;
    z-index: 2;
  }

  &.default:not(:focus-within):not(.has-value) label {
    ${BodySmallSemiBold};
    margin-top: 10px;
  }

  &:focus-within label,
  &.has-value label {
    ${BodyXSmallSemiBold};
  }

  &.has-value:not(:has(.label-hidden))::before {
    content: '';
    position: absolute;
    top: 1px;
    left: 1px;
    right: 1px;
    height: 35px;
    background: var(--input-bg-color, #ffffff);
    border-radius: var(--input-radius, 8px) var(--input-radius, 8px) 0 0;
    pointer-events: none;
    z-index: 1;
  }
`;

export const Label = styled.label`
  ${inputLabelBaseStyles};
  z-index: 2;
`;

export const TextAreaElement = styled.textarea`
  ${inputElStyles};
  min-height: var(--input-height);
  padding-top: 12px;
  padding-bottom: 12px;
  line-height: 1.5;
  flex: 1;
  min-width: 0;

  &:not(.label-hidden) {
    padding-top: 20px;
  }
`;
